import { makeStyles } from 'makeStyles';
import { BACKGROUND_RED } from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  formLabel: {
    margin: 0,
    '& + *': {
      marginTop: theme.spacing(1),
    },
  },
  formGroup: {
    '&:not(:first-of-type)': {
      marginTop: theme.spacing(2.5),
    },
  },
  suspensionPointsSelect: {
    marginTop: `${theme.spacing(1)}!important`,
  },
}));

export const useSuspensionPointsStyles = makeStyles()((theme) => ({
  card: {
    borderRadius: 5,
    boxShadow: '0 5px 20px 0 rgba(0, 0, 0, 0.04)',
    border: `solid 1px ${theme.palette.grey[200]}`,
    borderLeft: `2px solid ${BACKGROUND_RED}`,
    padding: theme.spacing(3),
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    '&:not(:first-of-type)': {
      marginTop: theme.spacing(3),
    },
  },
  cardContent: {
    fontSize: 14,
  },
  cardTitle: {
    color: BACKGROUND_RED,
    marginBottom: theme.spacing(1),
    fontSize: 15,
    fontWeight: 900,
  },
  cardActions: {
    display: 'flex',
    marginLeft: theme.spacing(3),
    '& > * + *': {
      marginLeft: theme.spacing(1),
    },
  },
  cardDateWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2.5),
    '& > * + *': {
      marginLeft: theme.spacing(1),
    },
  },
  cardFieldLabel: {
    fontWeight: 900,
  },
  cardCommentWrapper: {
    whiteSpace: 'pre-wrap',
    marginTop: theme.spacing(2.5),
    '& > * + *': {
      marginTop: theme.spacing(0.5),
    },
  },
  [theme.breakpoints.down('sm')]: {
    card: {
      flexDirection: 'column',
    },
    cardActions: {
      marginLeft: 0,
      marginTop: theme.spacing(3),
    },
  } as const,
}));
